"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetMeetingSearchServiceResponse", {
    enumerable: true,
    get: function() {
        return GetMeetingSearchServiceResponse;
    }
});
const _zod = require("zod");
const _meetings = require("../../../meetings");
const _base = require("../../base");
const GetMeetingSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _zod.z.union([
        _meetings.MeetingExtendedModel,
        _meetings.MeetingModel
    ]).array()
});
